import React, { useState, useEffect } from 'react';
import { FiX, FiSave } from 'react-icons/fi';
import axios from 'axios';
import { toast } from 'react-toastify';
import MemberForm from './MemberForm';
// const url = import.meta.env.VITE_BACKEND_URL;
const url = process.env.REACT_APP_BACKEND_URL;

const EditMember = ({ member, registerTypes, countries, regions, districts, onCancel, onSuccess }) => {
  const [formData, setFormData] = useState({
    registertype: '',
    fname: '',
    mname: '',
    lname: '',
    moname: '',
    mobile: '',
    email: '',
    password: '',
    cpassword: '',
    dob: '',
    pob: '',
    country: '',
    region: '',
    district: '',
    residence: '',
    sex: '',
    elevel: '',
    PaymentTerms: '',
    bankname: '',
    bankaddress: '',
    accno: '',
    nokname1: '',
    nokaddress1: '',
    nokmobile1: '',
    nokname2: '',
    nokaddress2: '',
    nokmobile2: '',
    photo: null,
    identity: null,
  });

  const [isSubmitting, setIsSubmitting] = useState(false);

  useEffect(() => {
    if (member) {
      const memberData = {
        ...member,
        country: member.country?._id || member.country || '',
        region: member.region?._id || member.region || '',
        district: member.district?._id || member.district || '',
        registertype: member.registertype?._id || member.registertype || '',
        password: '', // Clear password fields for security
        cpassword: '',
      };
      setFormData(memberData);
    }
  }, [member]);

  const handleSubmit = async (e) => {
    e.preventDefault();
    
    // Validate required fields
    const requiredFields = [
      'registertype', 'fname', 'lname', 'moname', 'mobile', 'email',
      'dob', 'pob', 'country', 'region', 'district',
      'residence', 'sex', 'elevel', 'PaymentTerms', 'bankaddress',
      'nokname1', 'nokaddress1', 'nokmobile1'
    ];

    for (const field of requiredFields) {
      if (!formData[field]) {
        toast.error(`Please fill ${field}`);
        return;
      }
    }

    // If password is provided, check if they match
    if (formData.password && formData.password !== formData.cpassword) {
      toast.error("Passwords don't match");
      return;
    }

    setIsSubmitting(true);
    
    try {
      const data = new FormData();

      for (const key in formData) {
        if (formData[key] !== null && formData[key] !== undefined) {
          // Only include password if it was changed
          if (key === 'password' && !formData[key]) continue;
          if (key === 'cpassword') continue;
          
          if (formData[key] instanceof File) {
            data.append(key, formData[key]);
          } else {
            data.append(key, formData[key]);
          }
        }
      }

      await axios.put(`${url}/api/members/${member._id}`, data, {
        headers: { "Content-Type": "multipart/form-data" }
      });
      
      onSuccess();
    } catch (err) {
      console.error('Error submitting form:', err);
      const errorMsg = err.response?.data?.message || 'Operation failed';
      toast.error(errorMsg);
    } finally {
      setIsSubmitting(false);
    }
  };

  return (
    <div className="members-form-container">
      <div className="form-header">
        <h2>Edit Member</h2>
        <button onClick={onCancel} className="close-btn">
          <FiX />
        </button>
      </div>

      <MemberForm
        formData={formData}
        setFormData={setFormData}
        onSubmit={handleSubmit}
        registerTypes={registerTypes}
        countries={countries}
        regions={regions}
        districts={districts}
        isEdit={true}
        viewMode={false}
      >
        <div className="form-actions">
          <button type="submit" className="submit-btn" disabled={isSubmitting}>
            <FiSave /> {isSubmitting ? 'Updating...' : 'Update Member'}
          </button>
          <button type="button" onClick={onCancel} className="cancel-btn">
            Cancel
          </button>
        </div>
      </MemberForm>
    </div>
  );
};

export default EditMember;